import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, y = 44, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.95, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export const MaskedLine = ({ children, delay = 0, animate = true }) => (
  <span className="block overflow-hidden pb-[0.08em]">
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={animate ? { y: 0 } : {}}
      transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.35em] text-[#FFFFFF] font-semibold ${className}`}>
    {children}
  </p>
);
